import { FRIDGE_TYPES, FridgeType } from '@gozoki/api-types';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

const zFridgeForm = z.object({
    reference: z
        .string()
        .max(50, {
            message: 'La référence doit comporter au maximum 50 caractères.',
        })
        .optional(),
    label: z
        .string()
        .nonempty({ message: 'Le libellé est requis.' })
        .max(100, { message: 'Le libellé doit comporter au maximum 100 caractères.' }),
    description: z
        .string()
        .max(500, {
            message: 'La description doit comporter au maximum 500 caractères.',
        })
        .optional(),
    type: z.enum([FRIDGE_TYPES.FRIDGE, FRIDGE_TYPES.COLD_ROOM] as [FridgeType, FridgeType]),
    storeReference: z
        .string()
        .nonempty({ message: 'La référence du magasin est requise.' })
        .max(50, {
            message: 'La référence du magasin doit comporter au maximum 50 caractères.',
        }),
});

export type FridgeForm = z.infer<typeof zFridgeForm>;

// Form hook
export const useFridgeForm = (defaultValues?: Partial<FridgeForm>) => {
    const form = useForm<FridgeForm>({
        // Validation function
        resolver: zodResolver(zFridgeForm),
        defaultValues: {
            reference: '',
            label: '',
            description: '',
            type: FRIDGE_TYPES.FRIDGE,
            storeReference: '',
            ...defaultValues,
        },
    });

    return form;
};
